import script from "./ClubEventTeamList.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubEventTeamList.vue?vue&type=script&setup=true&lang=js"

import "./ClubEventTeamList.vue?vue&type=style&index=0&id=a2cc42f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2cc42f6"]])

export default __exports__